module.exports = __webpack_public_path__ + "static/img/MiniProgram.e3cd8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/MiniProgram.jpg
// module id = 4ZL5
// module chunks = 9